import ManagePassword from "./ManagePassword";
import ManageProfile from "./ManageProfile";
import Utils from "@/components/Shared/Utils";
import ManageMultiFactor from "./ManageMultiFactor";
import UICard from "@/components/Shared/Utils/UICard";
import ManageAppSettings from "./ManageAppSettings";

export default function AccountInformation({customer, user}: any) {
    return (
        <Utils.LayoutUtils.MainContainer>
            <Utils.LayoutUtils.MainWrapper>
                <Utils.LayoutUtils.MainHeading
                    title="Customer Information"
                    description={`${customer?.customer_id || ''} - ${customer?.customer_email || user?.email}`}
                />
                <UICard gradient>
                    <ManageProfile customer={customer}/>
                </UICard>
                <UICard gradient>
                    <ManagePassword/>
                </UICard>
                <UICard gradient>
                    <ManageMultiFactor customer={customer}/>
                </UICard>
                <UICard gradient>
                    <ManageAppSettings />
                </UICard>
            </Utils.LayoutUtils.MainWrapper>
        </Utils.LayoutUtils.MainContainer>
    )
}